// frontend/src/pages/PacksPage.js

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../axiosInstance";
import "../styles/PacksPage.css";

export default function PacksPage() {
  const navigate = useNavigate();

  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errMsg, setErrMsg] = useState("");

  const normalizePack = (p) => {
    const id = p.id;

    const name =
      p.pack_name ||
      p.packName ||
      p.name ||
      p.title ||
      `Pack #${id}`;

    const coins =
      Number(p.coins_amount ?? p.coinsAmount ?? p.coins ?? 0) || 0;

    const price =
      Number(p.price_eur ?? p.priceEur ?? p.price_euros ?? p.price ?? 0) || 0;

    return { id, name, coins, price };
  };

  const load = async () => {
    setLoading(true);
    setErrMsg("");
    try {
      const res = await API.get("/coins/packs");
      const arr = Array.isArray(res.data) ? res.data : [];
      const cleaned = arr.map(normalizePack).filter((x) => x.id && x.coins > 0 && x.price > 0);
      setPacks(cleaned);
    } catch (e) {
      console.error("Erreur chargement packs:", e);
      setErrMsg("Impossible de charger les packs pour le moment.");
      setPacks([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sortedPacks = useMemo(() => {
    return [...packs].sort((a, b) => a.price - b.price);
  }, [packs]);

  const handleBuy = async (pack) => {
    // Si tu veux brancher paiement plus tard, c’est ici.
    // Pour l’instant, on garde un comportement “safe”.
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (!currentUser) {
      navigate("/login");
      return;
    }

    try {
      // Optionnel : tentative d’appel si ta route existe déjà
      // (sinon ça échoue mais ne casse pas l’UI).
      await API.post("/coins/purchase", { pack_id: pack.id });
      alert(`✅ Pack "${pack.name}" acheté !`);
    } catch (e) {
      console.warn("Achat non branché / erreur purchase:", e);
      alert("⚠️ Achat pas encore branché (paiement).");
    }
  };

  return (
    <div className="packs-neo">
      <div className="packs-neo-bg" />
      <div className="packs-neo-glow" />

      <header className="packs-neo-header">
        <div className="packs-neo-titlewrap">
          <div className="packs-neo-icon">🛒</div>
          <h1 className="packs-neo-title">Acheter des Coins</h1>
        </div>
        <div className="packs-neo-sub">
          Choisis un pack et recharge ton solde (style néon 😈)
        </div>
      </header>

      <main className="packs-neo-content">
        {loading && (
          <div className="packs-neo-loading">
            <div className="neo-spinner" />
            <div>Chargement des packs…</div>
          </div>
        )}

        {!loading && errMsg && (
          <div className="packs-neo-error">
            <div className="packs-neo-error-title">⚠️ {errMsg}</div>
            <button className="neo-btn neo-btn-outline" onClick={load}>
              Réessayer
            </button>
          </div>
        )}

        {!loading && !errMsg && sortedPacks.length === 0 && (
          <div className="packs-neo-empty">
            Aucun pack disponible
          </div>
        )}

        {!loading && !errMsg && sortedPacks.length > 0 && (
          <div className="packs-neo-grid">
            {sortedPacks.map((p) => (
              <div key={p.id} className="neo-pack-card">
                <div className="neo-pack-topline" />
                <div className="neo-pack-name">{p.name}</div>

                <div className="neo-pack-metrics">
                  <div className="neo-pack-coins">
                    <span className="neo-pack-coins-val">{p.coins}</span>
                    <span className="neo-pack-coins-lbl">coins</span>
                  </div>

                  <div className="neo-pack-price">
                    {p.price.toFixed(2)}€
                  </div>
                </div>

                <button
                  className="neo-btn neo-btn-primary"
                  onClick={() => handleBuy(p)}
                >
                  Acheter
                </button>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
